export * from './domain/person';
